// extracted by mini-css-extract-plugin
export var details = "_fy-0";
export var inspectorPopover = "_fy-1";